/**
 * A function to concatenate a tagged template literal and its substitutions.
 *
 * @param {TemplateStringsArray} strings - The raw strings from the template literal.
 * @param {...any} values - The substitution values in the template literal.
 * @returns {string} The resulting string, with substitutions inserted.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function twSort(strings: TemplateStringsArray, ...values: any[]): string {
  let result = '';
  strings.forEach((string, i) => {
    result += string + (values[i] || '');
  });
  return result;
}

export const contentAlignmentStyle = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};

export const textAlignmentStyle = {
  left: 'text-start',
  center: 'text-center',
  right: 'text-end',
};

export function cs(str: string) {
  return `corner-square-circle ${CSS.supports('corner-shape', 'squircle') ? str : ''}`;
}
